// @TODO: maybe refactor using a generic local storage hook
import * as React from 'react';
import { useParams } from 'react-router';

import { useAuth } from '@/utils/auth';

type StoredPortfolio = {
  id: string;
  type: 'portfolio' | 'fund' | 'enhanced';
  name?: string;
};
type StoredPortfolios = Record<string, StoredPortfolio[]>;
const lastDetailsIdKey = 'recentPortfolios';

const getAllOrgsRecentPortfolios = () => {
  const storedPortfolios = localStorage.getItem(lastDetailsIdKey);
  if (!storedPortfolios) return {};

  try {
    return (JSON.parse(storedPortfolios) as StoredPortfolios) || {};
  } catch (error) {
    console.error('Error parsing stored IDs:', error);
    return {};
  }
};

const getRecentPortfolios = (organizationId: string): StoredPortfolio[] => {
  const storedPortfolios = getAllOrgsRecentPortfolios();
  return storedPortfolios[organizationId] || [];
};

const addRecentPortfolio = (organizationId: string, { id, type, name }: StoredPortfolio) => {
  const allOrgsRecentPortfolios = getAllOrgsRecentPortfolios();
  const recentPortfolios = getRecentPortfolios(organizationId);

  if (recentPortfolios.some(entry => entry.id === id)) {
    recentPortfolios.sort((a, b) => (a.id === id ? -1 : b.id === id ? 1 : 0));
  } else {
    // add new id to the beginning of the list
    recentPortfolios.unshift({ id, type, name });
    // limit the number of stored IDs to 3
    if (recentPortfolios.length > 4) {
      recentPortfolios.length = 4;
    }
  }

  allOrgsRecentPortfolios[organizationId] = recentPortfolios;
  localStorage.setItem(lastDetailsIdKey, JSON.stringify(allOrgsRecentPortfolios));
};

export const setRecentPortfolioName = (organizationId: string, { id, name }: Omit<StoredPortfolio, 'type'>) => {
  const allOrgsRecentPortfolios = getAllOrgsRecentPortfolios();
  const recentPortfolios = getRecentPortfolios(organizationId);
  const recentPortfolioIndex = recentPortfolios.findIndex(entry => entry.id === id && !entry.name);
  if (recentPortfolioIndex !== -1) {
    recentPortfolios[recentPortfolioIndex].name = name;
    allOrgsRecentPortfolios[organizationId] = recentPortfolios;
    localStorage.setItem(lastDetailsIdKey, JSON.stringify(allOrgsRecentPortfolios));
  }
};

export const useRecentPortfolios = () => {
  const { fundId, portfolioId, enhancedId } = useParams();
  const { currentOrganization } = useAuth();
  const [recentPortfolios, setRecentPortfolios] = React.useState<StoredPortfolio[]>(
    getRecentPortfolios(currentOrganization?.id || '')
  );

  React.useEffect(() => {
    const id = portfolioId || fundId || enhancedId;
    if (id && currentOrganization?.id) {
      addRecentPortfolio(currentOrganization.id, {
        id,
        type: portfolioId ? 'portfolio' : fundId ? 'fund' : 'enhanced',
      });
      setRecentPortfolios(getRecentPortfolios(currentOrganization.id));
    }
  }, [fundId, portfolioId, enhancedId, currentOrganization?.id]);

  return recentPortfolios;
};
